import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { ServiceUserManualModel } from "@/core/models/service-user-manual.model";

interface _ServiceUserManualGetParams {
    search?: string;
}

@injectable()
export class ServiceUserManualRepo extends TableRepo<ServiceUserManualModel> {
    constructor() {
        super("/api/ServiceUserManual");
    }

    async getData(index: number, params: _ServiceUserManualGetParams, pageSize = 10): Promise<ApiPage<ServiceUserManualModel>|null> {
        return await super.getData(index, params, pageSize);
    }
}